
import './style.scss';
import { Popover as MuiPopover, PopoverProps } from '@mui/material';



export interface IDefaultPopoverProps extends PopoverProps {
    handleClose: () => void;
}


const Popover: React.FC<PopoverProps> = (props) => {
    return (
        <MuiPopover
            {...props}
            hideBackdrop={props.hideBackdrop ?? true}
            className={`popover-default ${props.className ?? ''}`}
        >
            {props.children}
        </MuiPopover>
    );
}

export default Popover;